export default "__VITE_ASSET__D32BrM69__"